import { Box, Typography, alpha, useTheme } from '@mui/material';
import { Monitor, Search, MessageSquare, FileText, PenTool, Clock } from 'lucide-react';

const KPICard = ({ icon, label, value, color }) => {
  const theme = useTheme();
  return (
    <Box sx={{
      flex: '1 1 140px', p: 2, borderRadius: '12px',
      border: `1px solid ${theme.palette.divider}`,
      bgcolor: theme.palette.background.paper,
      display: 'flex', alignItems: 'center', gap: 1.5,
    }}>
      <Box sx={{
        p: 1, borderRadius: '8px',
        bgcolor: alpha(color, 0.1), color,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        {icon}
      </Box>
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 700, color: theme.palette.text.primary, lineHeight: 1.2 }}>
          {value ?? 0}
        </Typography>
        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>{label}</Typography>
      </Box>
    </Box>
  );
};

const formatDuration = (seconds) => {
  if (!seconds) return '0m';
  const mins = Math.round(seconds / 60);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  const rem = mins % 60;
  return rem ? `${hrs}h ${rem}m` : `${hrs}h`;
};

const UserAnalyticsSummary = ({ summary }) => {
  const theme = useTheme();
  const p = theme.palette.primary.main;
  const s = theme.palette.success.main;
  const i = theme.palette.info.main;
  const w = theme.palette.warning.main;

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
      <KPICard icon={<Monitor size={20} />} label="Sessions" value={summary.total_sessions} color={p} />
      <KPICard icon={<Search size={20} />} label="Searches" value={summary.total_searches} color={s} />
      <KPICard icon={<MessageSquare size={20} />} label="Conversations" value={summary.total_conversations} color={i} />
      <KPICard icon={<FileText size={20} />} label="Contracts" value={summary.total_contracts} color={w} />
      <KPICard icon={<PenTool size={20} />} label="Signatures" value={summary.total_signatures} color={theme.palette.secondary.main || '#9c27b0'} />
      <KPICard icon={<Clock size={20} />} label="Avg Session" value={formatDuration(summary.avg_session_duration_seconds)} color={theme.palette.text.secondary} />
    </Box>
  );
};

export default UserAnalyticsSummary;
